import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=3fc313e4&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=3fc313e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc313e4",
  null
  
)

export default component.exports